import { useTranslation } from 'react-i18next'

import { CircleDashedIcon, EyeIcon, QuestionIcon, XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, Button, Card, CardTitle, PackageCheckIcon } from '@reveni-io/reveni-ui'

import SummaryBox from './SummaryBox/SummaryBox'
import { groupItemsByDecision } from './helpers'
import * as Styles from './styles'

const SummaryCard = ({ items, onCancel, onConfirm, confirmDisabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { pending, byOrder, discarded } = groupItemsByDecision(items)

  return (
    <Card>
      <CardTitle>{t('Resumen')}</CardTitle>
      <Styles.BoxesContainer>
        {pending.length > 0 && (
          <SummaryBox
            title={t('Productos pendientes')}
            items={pending}
            TitleIcon={QuestionIcon}
            RowIcon={CircleDashedIcon}
            rowIconColor={theme.colors.text.subtle}
          />
        )}
        {byOrder.map(group => (
          <SummaryBox
            key={group.order?.id}
            title={`#${group.order?.number}`}
            items={group.items}
            TitleIcon={PackageCheckIcon}
            RowIcon={EyeIcon}
            rowIconColor={theme.colors.accent.default}
          />
        ))}
        {discarded.length > 0 && (
          <SummaryBox title={t('Productos descartados')} items={discarded} TitleIcon={XIcon} RowIcon={XIcon} />
        )}
      </Styles.BoxesContainer>
      {!confirmDisabled && (
        <Styles.AlertSlot>
          <Alert type="warning" size="l">
            {t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}
          </Alert>
        </Styles.AlertSlot>
      )}
      <Styles.Actions>
        <Button onClick={onConfirm} disabled={confirmDisabled} fullWidth>
          {t('Confirmar')}
        </Button>
        <Button variant="outlined" onClick={onCancel} fullWidth>
          {t('Cancelar')}
        </Button>
      </Styles.Actions>
    </Card>
  )
}

export default SummaryCard
